<template>
    <v-card class="mx-2 pb-5">
    <!-- title -->
        <v-card-title class="px-5 pt-5 pb-2">
            <v-icon class="mr-3" v-if="$vuetify.breakpoint.mdAndUp">mdi-card-account-details</v-icon>
            <span class="heebo fw600">Kugel-Pässe drucken</span>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="refreshPaesse()" v-if="printKugelPaesse.filter.show!=='export'">
                <v-icon class="mr-1">mdi-refresh</v-icon>Aktualisieren</v-btn>
        </v-card-title>
    <!-- search header -->
        <v-radio-group v-if="printKugelPaesse" v-model="printKugelPaesse.filter.show" row class="mx-5 mt-0" hide-details>
            <v-radio label="zeige Kugeln die auf Pass-Druck warten" value="pending" class="mb-2"/>
            <v-radio label="zeige Druck-Historie" value="history" class="mb-2"/>
            <v-radio label="Kugelpässe exportieren" value="export" class="mb-2"/>
        </v-radio-group>
    <!-- search history && export -->
        <div v-if="printKugelPaesse.filter.show==='export'">
            <div class="mx-5 primary--text subtitle-2 py-3">Bitte wähle deinen Filter für den Export:</div>
            <v-radio-group v-model="printKugelPaesse.filter.sportart" row class="mx-5 mt-0" hide-details>
                <v-radio label="Classic" value="classic" class="mb-2"/>
                <v-radio label="Bowling" value="bowling" class="mb-2"/>
            </v-radio-group>
            <v-radio-group v-model="printKugelPaesse.filter.allOrTimeframe" row class="mx-5 mt-0" hide-details>
                <v-radio label="alle" :value="true" class="mb-2"/>
                <v-radio label="nach Druckdatum" :value="false" class="mb-2"/>
            </v-radio-group>
        </div>
        <v-row no-gutters align="center" v-if="printKugelPaesse.showDateFilter()" class="mb-3">
            <v-col class="px-5">
                <v-text-field v-model="printKugelPaesse.filter.from" type="date" hide-details label="gedruckt von"/>
            </v-col>
            <v-col class="px-5">
                <v-text-field v-model="printKugelPaesse.filter.until" type="date" hide-details label="gedruckt bis"/>
            </v-col>
        </v-row>
        <v-alert v-if="printKugelPaesse.filter.error" text color="error" class="mx-5">{{printKugelPaesse.filter.error}}</v-alert>
        <div v-if="printKugelPaesse.filter.show==='export'" class="text-right px-5">
            <v-alert text color="warning" dense class="text-left mt-3">
                ACHTUNG: wenn du mehrmals täglich alle Kugelpässe exportierst, kann das Serverkosten verursachen!</v-alert>
            <v-btn color="primary" @click="exportToExcel()">
                <v-icon class="mr-1">mdi-download</v-icon>Nach Excel exportieren</v-btn>
        </div>
    <!-- list -->

        <kugel-paesse-liste v-if="printKugelPaesse.filter.show !== 'export'" :print-kugel-paesse="printKugelPaesse" />
        <v-snackbar v-model="showSnack" color="success">Es wurden {{noOfExportedItems}} Kugeln exportiert!</v-snackbar>
    </v-card>
</template>

<script>

import {KugelPaesseService} from "@/services/data/kugeln/kugelPaesseService";
import KugelPaesseListe from "@/views/kugeln/paesse/kugelPaesseListe";

export default {
    name: "kugel-paesse",
    components: {KugelPaesseListe},
    data: () => ({
        printKugelPaesse: null,
        noOfExportedItems: 0,
        showSnack: false,
    }),
    created(){
        this.init()
    },
    methods: {
        init(){
            if ( !this.printKugelPaesse ) {
                this.printKugelPaesse = new KugelPaesseService()
                this.printKugelPaesse.setHistoryDates(true)
            }
        },
        async refreshPaesse(){
            await this.printKugelPaesse.setPendingPassList(true)
        },
        async exportToExcel(){
            this.noOfExportedItems = await this.printKugelPaesse.exportToExcel()
            if ( this.noOfExportedItems >= 0 ) this.showSnack = true
        }
    },
    watch: {
        'printKugelPaesse.filter.show'(){
            this.printKugelPaesse.setHistoryDates(true)
            this.printKugelPaesse.setPendingPassList()
        },
    }
}
</script>

<style scoped>

</style>